// Date placeholders in scheduled task names — browser twin of
// api/utils/tasks/placeholders.ts (CRA can't import from api/). Keep in step.
//
//   [date] Oct 9   [day] Friday   [week] Oct 5–11
//   [month] October   [year] 2026   [quarter] Q4
import { addDays, mondayOf, parseDay } from './taskDates';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const PLACEHOLDER_HELP: { token: string; example: string }[] = [
  { token: '[date]', example: 'Oct 9' },
  { token: '[day]', example: 'Friday' },
  { token: '[week]', example: 'Oct 5–11' },
  { token: '[month]', example: 'October' },
  { token: '[year]', example: '2026' },
  { token: '[quarter]', example: 'Q4' },
];

const PLACEHOLDER_RE = /[[{](date|day|week|month|year|quarter)[\]}]/gi;

const short = (d: Date) => `${MONTHS[d.getMonth()].slice(0, 3)} ${d.getDate()}`;

function weekRange(day: string): string {
  const start = parseDay(mondayOf(day));
  const end = parseDay(addDays(mondayOf(day), 6));
  return start.getMonth() === end.getMonth() ? `${short(start)}–${end.getDate()}` : `${short(start)}–${short(end)}`;
}

export function hasPlaceholders(text: string): boolean {
  PLACEHOLDER_RE.lastIndex = 0;
  const found = PLACEHOLDER_RE.test(text || '');
  PLACEHOLDER_RE.lastIndex = 0;
  return found;
}

export function fillPlaceholders(text: string, day: string): string {
  if (!hasPlaceholders(text)) return text;
  const d = parseDay(day);
  return text.replace(PLACEHOLDER_RE, (match, token: string) => {
    switch (token.toLowerCase()) {
      case 'date':
        return short(d);
      case 'day':
        return DAYS[d.getDay()];
      case 'week':
        return weekRange(day);
      case 'month':
        return MONTHS[d.getMonth()];
      case 'year':
        return String(d.getFullYear());
      case 'quarter':
        return `Q${Math.floor(d.getMonth() / 3) + 1}`;
      default:
        return match;
    }
  });
}
